import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'underscore'

import CurrencyClass from './../../../../../../../../../js/classes/Currency.js'
import AppClass from './../../../../../../../../../js/classes/App.js'

const SelectPickPoint = ({ handleSelectPickPoint, data, delivery }) => {
    const deliveryPickPoint = data?.delivery_pick_points[delivery.ID]

    return deliveryPickPoint && <div className="happy-order__select-pick-point" data-pick-point-code={ deliveryPickPoint?.VALUE?.POINT_GUID }>
        { deliveryPickPoint.VALUE ? <span
            className="happy-order__select-pick-point-address"
            onClick={ handleSelectPickPoint }
        >
            <strong>{ deliveryPickPoint?.VALUE?.NAME }</strong> — { deliveryPickPoint?.VALUE?.FULL_ADDRESS }
        </span> : <span
            className="happy-order__select-pick-point-button"
            onClick={ handleSelectPickPoint }
        >
            Выбрать точку самовывоза
        </span> }
    </div>
}

const DeliveryItem = ({ delivery, data, handleChangeDelivery, handleSelectPickPoint }) => {
    let price_format = null,
    price_class_name = '',
    date_format = null

    if (delivery.ID === 64 || delivery.ID === 66 || delivery.ID === 67) {
        delivery.PRICE = false
    }

    //PRICE
    if (delivery.PRICE == 0) {
        price_format = 'Бесплатно'
        price_class_name = 'happy-order__delivery-item-price_green'
    } else if (delivery.PRICE > 0) {
        price_format = CurrencyClass.format(delivery.PRICE)

        if (delivery.NAME.toUpperCase().includes('СБЕР')) {
            price_format = `от ${ price_format }`
        }
    } else if (delivery.PRICE === null) {
        price_format = 'Идёт расчёт..'
        price_class_name = 'happy-order__delivery-item-price_green'
    }

    //DATE
    let dateUnit = 0

    if (delivery.PERIOD_TYPE == 'MIN') {
        dateUnit = 1000 * 60
    } else if (delivery.PERIOD_TYPE == 'H') {
        dateUnit = 1000 * 60 * 60
    } else if (delivery.PERIOD_TYPE == 'D') {
        dateUnit = 1000 * 60 * 60 * 24
    } else if (delivery.PERIOD_TYPE == 'M') {
        dateUnit = 1000 * 60 * 60 * 24 * 30
    }
    
    if (delivery.PERIOD_FROM > 0 && delivery.PERIOD_TO == 0) {
        let dateUnitFormat = ['', '', '']

        if (delivery.PERIOD_TYPE == 'MIN') {
            dateUnitFormat = ['минуты', 'минут', 'минут'];
        } else if (delivery.PERIOD_TYPE == 'H') {
            dateUnitFormat = ['часа', 'часов', 'часов'];
        } else if (delivery.PERIOD_TYPE == 'D') {
            dateUnitFormat = ['деня', 'дней', 'дней'];
        } else if (delivery.PERIOD_TYPE == 'M') {
            dateUnitFormat = ['месяца', 'месяцев', 'месяцев'];
        }

        date_format = `от ${ AppClass.declension(delivery.PERIOD_FROM, dateUnitFormat[0], dateUnitFormat[1], dateUnitFormat[2]) }`
    }

    if (delivery.PERIOD_TO > 0 && delivery.PERIOD_TO > delivery.PERIOD_FROM) {
        if (dateUnit > 0) {
            const d = new Date((new Date().getTime()) + (dateUnit * delivery.PERIOD_TO)),
            dD = d.getDate() < 10 ? '0' + d.getDate() : d.getDate(),
            dM = d.getMonth() < 10 ? '0' + d.getMonth() : d.getMonth()

            date_format = `${ dD }.${ dM }`
        }
    }

    if (delivery._IS_LOADING) {
        if (delivery.PRICE === null) {
            date_format = ''
        } else {
            date_format = delivery.PERIOD
        }
    }

    /*
    if (delivery.NAME === 'Почта России') {
        const d = new Date((new Date().getTime()) + 1000 * 60 * 60 * 24 * 3),
        dD = d.getDate() < 10 ? '0' + d.getDate() : d.getDate(),
        dM = d.getMonth() < 10 ? '0' + d.getMonth() : d.getMonth()

        date_format = `${ dD }.${ dM }`
        price_format = 'от ' + price_format
    }
    */

    if ((_.isArray(delivery._ERRORS) && delivery._ERRORS.length > 0) || (delivery.PRICE === null && delivery.PERIOD === null)) {
        date_format = ''
        price_format = 'Доставка не доступна'
    }

    if (delivery.NAME.toLowerCase() === 'самовывоз') {
        price_format = 'Бесплатно'
        price_class_name = 'happy-order__delivery-item-price_green'
    }

    if (delivery.ID === 64) {
        date_format = '1 день'
        price_format = 'от 1000 ₽ до 2000 ₽'
        price_class_name = ''
    }

    if (delivery.ID === 66) {
        date_format = 'до 1 дня'
        price_format = '350 ₽ + 50 ₽ за каждый км. до адреса'
        price_class_name = ''
    }

    if (delivery.ID === 67) {
        date_format = 'до 1 дня'
        price_format = '500 ₽ + 50 ₽ за каждый км. до адреса'
        price_class_name = ''
    }
    
    return <div className={ `happy-order__delivery-item${ data.delivery.id == delivery.ID ? ' happy-order__delivery-item_active' : '' }` } onClick={ handleChangeDelivery.bind(this, delivery) }>
        <div className="happy-order__delivery-item-title">
            <div className="happy-order__delivery-item-title__label" dangerouslySetInnerHTML={ { __html : delivery.NAME } } />
            <div className="happy-order__delivery-item-title__description" dangerouslySetInnerHTML={ { __html : delivery.DESCRIPTION } } />
        </div>
        <div className="happy-order__delivery-item-date">
            { date_format }
        </div>
        <div className={ `happy-order__delivery-item-price${ ' ' + price_class_name }` }>
            { price_format }
        </div>

        { data?.delivery_pick_points[delivery.ID]
        && data.delivery.id == delivery.ID
        && <SelectPickPoint
            handleSelectPickPoint={ handleSelectPickPoint }
            data={ data }
            delivery={ delivery }
        /> }
    </div>
}

export default DeliveryItem